import { compose, space, color, typography } from 'styled-system';
import { createComponent } from '../utils';
export var Text = createComponent({
    name: 'Text',
    tag: 'span',
    style: compose(space, color, typography),
});
//# sourceMappingURL=Text.js.map